































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { mask } from 'vue-the-mask'
import {
  formatDateForDisplay,
  getDateMask,
  parseDateFromDisplay,
} from '../utils'
@Component({
  directives: { mask },
})
export default class DateSelect extends Vue {
  @Prop({ default: null }) readonly value!: string | null
  @Prop({ default: '' }) readonly label!: string | Record<string, any>
  @Prop({ default: false, type: Boolean }) readonly clearable!: boolean

  menu = false
  displayDate: string | null = null
  errorMessages: string[] = []

  get dateMask() {
    return getDateMask(this.$i18n.locale)
  }

  @Watch('value', { immediate: true })
  onChangeValue(value: string | null) {
    this.displayDate = formatDateForDisplay(value, this.$i18n.locale)
  }

  get clearIcon() {
    return this.model ? 'clear' : null
  }
  get model() {
    return this.value
  }
  set model(value) {
    this.errorMessages = []
    this.$emit('input', value)
    this.$emit('change', value)
  }
  onChange() {
    if (!this.displayDate) {
      this.model = null
      return
    }

    const parsed = parseDateFromDisplay(this.displayDate, this.$i18n.locale)
    if (!parsed) {
      this.errorMessages.push(String(this.$t('dateSelect.message.invalidDate')))
      return
    }

    this.model = parsed
  }
}
